import toast from "react-hot-toast";
import AlertMessage from "@/components/alert-message/AlertMessage";
import type { AlertMessageProps } from "@/components/alert-message/AlertMessage";

type BaseOptions = Omit<
  AlertMessageProps,
  "contentType" | "onClose" | "titleLabel" | "textLabel"
>;

function show(
  contentType: AlertMessageProps["contentType"],
  titleLabel: AlertMessageProps["titleLabel"],
  textLabel: AlertMessageProps["textLabel"],
  options?: BaseOptions,
) {
  toast.custom(
    (t) => (
      <AlertMessage
        {...options}
        contentType={contentType}
        titleLabel={titleLabel}
        textLabel={textLabel}
        onClose={() => toast.dismiss(t.id)}
      />
    ),
    {
      duration: 5000,
    },
  );
}

export const appToast = {
  success: (
    titleLabel: AlertMessageProps["titleLabel"],
    textLabel: AlertMessageProps["textLabel"],
    options?: BaseOptions,
  ) => show("success", titleLabel, textLabel, options),

  error: (
    titleLabel: AlertMessageProps["titleLabel"],
    textLabel: AlertMessageProps["textLabel"],
    options?: BaseOptions,
  ) => show("error", titleLabel, textLabel, options),

  warning: (
    titleLabel: AlertMessageProps["titleLabel"],
    textLabel: AlertMessageProps["textLabel"],
    options?: BaseOptions,
  ) => show("warning", titleLabel, textLabel, options),

  info: (
    titleLabel: AlertMessageProps["titleLabel"],
    textLabel: AlertMessageProps["textLabel"],
    options?: BaseOptions,
  ) => show("info", titleLabel, textLabel, options),
};
